import { useState } from "react";
import { CONNECTION_STATUS } from "./constants"

const useConnectionStatus = () => {
    const [connectionStatus,setConnectionStatus] = useState(CONNECTION_STATUS.ONLINE);
    window.addEventListener('offline',()=>{
        setConnectionStatus(CONNECTION_STATUS.OFFLINE);
    })
    window.addEventListener('online',()=>{
        setConnectionStatus(CONNECTION_STATUS.ONLINE);
    })
    return connectionStatus;
}
export default useConnectionStatus;